import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDocumentFolder(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 11.47V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v6.47M9 8h5m-1.898 5.81 7.597-2.4a1 1 0 0 1 1.301.954V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.635a1 1 0 0 1 1.301-.954l7.597 2.399a2 2 0 0 0 1.204 0"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentFolder);
export default ForwardRef;
